import { type PropsWithChildren } from 'react'

export function Allow({ children }: PropsWithChildren) {
  return <>{children}</>
}
